import { render, staticRenderFns } from "./RecommendedOffers.vue?vue&type=template&id=7bcb696c&scoped=true&"
import script from "./RecommendedOffers.vue?vue&type=script&lang=js&"
export * from "./RecommendedOffers.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedOffers.vue?vue&type=style&index=0&id=7bcb696c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcb696c",
  null
  
)

export default component.exports